import { useEffect } from "react";
import { safeTraverse } from "../scene/sceneObjectLookups";

export function useJointVisualizationEvents({
  findJointVizGroup,
  getJointSnapshot,
  jointLookup,
  jointVizVisibility,
  sceneObjects,
  sceneRef,
  selectedJoint,
  showJoints,
  slideJointLimitControlsRef,
}) {
  // Store-driven per-joint viz visibility
  useEffect(() => {
    if (!sceneRef.current) return;
    safeTraverse(sceneRef.current, (obj) => {
      if (!obj || !obj.userData || !obj.userData.isJointVizGroup) return;
      const uuid = obj.userData.jointUuid;
      const hasExplicitVisibility =
        uuid &&
        jointVizVisibility &&
        Object.prototype.hasOwnProperty.call(jointVizVisibility, uuid);
      let visibilityKey = null;
      if (hasExplicitVisibility) {
        visibilityKey = uuid;
      }
      const baseVisible =
        visibilityKey !== null ? !!jointVizVisibility[visibilityKey] : !!showJoints;
      const selectedOverride = !hasExplicitVisibility && uuid != null && selectedJoint === uuid;
      const visible = baseVisible || selectedOverride;
      if (typeof obj.userData.updateVisibility === "function") {
        obj.userData.updateVisibility(visible);
      } else {
        obj.visible = visible;
      }
    });
  }, [showJoints, jointVizVisibility, selectedJoint, sceneObjects, sceneRef]);

  useEffect(() => {
    const onSlideLimitVisualControls = (event) => {
      const { jointUuid, minEnabled, maxEnabled, min, max } = event.detail || {};
      if (!jointUuid) return;
      slideJointLimitControlsRef.current[jointUuid] = {
        minEnabled: minEnabled !== false,
        maxEnabled: maxEnabled !== false,
      };
      const jointData = getJointSnapshot(jointUuid);
      const viz = findJointVizGroup(jointUuid);
      if (!jointData || !viz?.userData?.updateAll) return;
      viz.userData.updateAll(
        Number.isFinite(Number(min)) ? Number(min) : jointData.min,
        Number.isFinite(Number(max)) ? Number(max) : jointData.max,
        jointData.axis,
        jointData.useLimits,
        slideJointLimitControlsRef.current[jointUuid],
        jointData.current
      );
    };
    window.addEventListener(
      "slide-joint-limit-visual-controls-updated",
      onSlideLimitVisualControls
    );
    return () =>
      window.removeEventListener(
        "slide-joint-limit-visual-controls-updated",
        onSlideLimitVisualControls
      );
  }, [jointLookup, slideJointLimitControlsRef, getJointSnapshot, findJointVizGroup]);
}
